import {
    Component, OnInit, ViewChild, EventEmitter, Input, Output, ViewEncapsulation
    , ChangeDetectionStrategy, OnDestroy, TemplateRef
} from '@angular/core';
import { Subscription, Observable, pipe } from 'rxjs';
import { SortDirection, SelectionMode, EntityState, EditableMode, FieldTypes, MessageTypes } from 'app/shared/model/enums';
import { LazyLoadEvent, SortEvent } from 'primeng/api';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { AdvMessageService } from 'app/shared/services/message.service';
import { FilterPipe } from 'app/shared/pipes/filter.pipe';
import { FilterMetadata } from 'primeng/api';
import { environment } from 'environments/environment';
import { CurrencyPipe } from '@angular/common';
import { Filter } from '../filter';
import { ToolbarButton } from '../toolbarButton';
import { BooleanFilter } from '../booleanFilter';
import { TableLazyLoadEvent } from 'primeng/table';



@Component({
    selector: 'app-readonly-table',
    templateUrl: './readonly-table.component.html',
    styleUrls: ['./readonly-table.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReadonlyTableComponent implements OnInit, OnDestroy {
    showColums: number;
    itemsSubscribe: Subscription;

    constructor(private filterPipe: FilterPipe,
        public messageService: AdvMessageService, public localizationService: LocalizationService) {

    }

    //#region public Members
    @ViewChild('dt', { static: false }) table: any;
    public backSortField: string;
    public controls = [];
    public loading: boolean;
    public pageName = "ReadOnlyTableComponent";
    public subscriptions: Subscription = new Subscription();
    math = Math;
    search: boolean;
    labelSearch: string;
    he: any;
    direction
    popupType
    get inputTemplate() { return FieldTypes; }


    //#endregion

    //#region Input/Output Members
    @Input() itemsSource$: Observable<any[]>;
    _selectedItems: any[] = [];
    @Output() selectedItemsChange = new EventEmitter();
    @Input() get selectedItems(): any[] { return this._selectedItems; }
    set selectedItems(val: any[]) {
        this._selectedItems = val;
        this.selectedItemsChange.emit(this.selectedItems);
    }
    _filters;
    @Output() filtersChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() get filters() { return this._filters; }
    set filters(filters) {
        this._filters = filters;
        this.filtersChange.emit(filters);
    }
    _pageSize = 25;
    @Output() pageSizeChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() get pageSize(): number { return this._pageSize; }
    set pageSize(pageSize: number) {
        this._pageSize = pageSize;
        this.pageSizeChange.emit(pageSize);
    }
    _sortField: string | string [];
    @Output() sortFieldChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() get sortField(): string | string[] { return this._sortField; }
    set sortField(sortField: string | string []) {
        this._sortField = sortField;
        this.sortFieldChange.emit(sortField);
    }
    _sortDirection: SortDirection = SortDirection.Asc;
    @Output() sortDirectionChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() get sortDirection(): number { return this._sortDirection; }
    set sortDirection(sortDirection: number) {
        this._sortDirection = sortDirection;
        this.sortDirectionChange.emit(sortDirection);
    }
    _currentPage = 1;
    @Output() currentPageChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() get currentPage(): number { return this._currentPage; }
    set currentPage(currentPage: number) {
        this._currentPage = currentPage;
        this.currentPageChange.emit(currentPage);
    }

    //#endregion 
    _columns: any[] = [];
    searchDefinitions: any[]
    @Input() get columns(): any[] { return this._columns; }
    set columns(columns: any[]) {
        this._columns = columns;
        this.searchDefinitions = this.filterPipe.buildSearchDefinitions(this.columns);
    }
    //#region Input Members
    @Input() globalFilterFields: any[]
    @Input() toolbarExternalButtons: ToolbarButton[];
    // @Input() columns: any[] = [];
    @Input() dividedTable: boolean;
    @Input() fieldForRowClass: string;
    @Input() valueForRowClass: any;
    @Input() totalRecords;
    @Input() isLoadLazy: boolean;
    @Input() paginator = true;
    @Input() rowsPerPageOptions = [5, 10, 15, 20, 25, 50, 100]
    @Input() alwaysShow = true;
    @Input() isFilterable = true;
    @Input() showToolbar: boolean;
    @Input() hideToolBarActions: boolean;
    @Input() hiddenSelectors = true; // if it's false, selectionMode must be none
    @Input() useExternalSource = false;
    @Input() saveTableAction: any;
    @Input() title: string;
    @Input() selectionMode: 'single' | 'multiple';
    @Input() dataKey: string;
    @Input() editMode: 'cell' | 'row';
    @Input() newHidden: boolean;
    @Input() deleteHidden: boolean;
    @Input() saveHidden: boolean;
    @Input() exportHidden: boolean;
    @Input() ngClassColumn: string;
    @Input() ngClassValueCondition: any;
    @Input() ngClassStyle: string;
    @Input() hiddenTotalRecord: boolean;
    @Input() hasCustomValidations = false;
    @Input() hasSummaryColumn = false;
    @Input() booleansFilters: BooleanFilter[] = [];
    @Input() customValidations: (value: any) => string;
    @Input() rowExpand = false;
    @Input() rowExpandTemplate: TemplateRef<any>;
    @Input() isClickableRow: boolean;
    @Input() searchTerm: string;
    @Input() scrollable: boolean;
    @Input() scrollHeight: string;
    @Input() pageNo: any;

    //#endregion

    //#region Output Members
    @Output() externalButtonClick = new EventEmitter<any>();
    @Output() onChangeFilter = new EventEmitter();
    @Output() onLoadData = new EventEmitter<any>();
    @Output() onRowClick = new EventEmitter();
    @Output() onAddNew = new EventEmitter();
    @Output() onDeleteSelectedRows = new EventEmitter();
    @Output() onSave: EventEmitter<any[]> = new EventEmitter();
    @Output() setTotalRecords = new EventEmitter();
    @Output() fieldChanged: EventEmitter<any> = new EventEmitter();
    @Output() fieldFocus: EventEmitter<any> = new EventEmitter();
    @Output() onRowSelect: EventEmitter<any> = new EventEmitter();
    @Output() onRowUnSelect: EventEmitter<any> = new EventEmitter();
    @Output() fieldBlur = new EventEmitter();
    @Output() onRowExpand: EventEmitter<any> = new EventEmitter();
    @Output() onFilter: EventEmitter<any[]> = new EventEmitter();
    @Output() onRowClicked: EventEmitter<any> = new EventEmitter<any>()
    @Output() onPageChange: EventEmitter<any> = new EventEmitter<any>()
    @Output() onViewDetails: EventEmitter<any> = new EventEmitter<any>()
    @Output() sortChange = new EventEmitter<{ field: string, order: number }>();

    @ViewChild('p-calendar') calendar: any;
    //#endregion
    cols
    cars
    totalRecordsText = ""
    onSort(event)
    {
  
     this.sortChange.emit(event);
    }
    //#region Angular lifecycle Methods
    ngOnInit() {
        this.showColums = this.columns.filter(col => !col.hidden).length;
        this.search = false;

        this.totalRecordsText = this.localizationService.Translate('CUSTOMERS.TOTALRECORDS_DESCRIPTION', {
            totalRecords: this.totalRecords
        });
        this.labelSearch = this.localizationService.Translate('GENERAL.SEARCH');
        // this.itemsSubscribe = this.itemsSource$.subscribe(items => { this.items = items });
        this.loading = true;
        if (!this.useExternalSource) {
            this.setTotalRecords.emit();
        }
        if (!this.isLoadLazy) {
            this.onLoadData.emit();
            this.loading = false;
        }
        this.he = {
            firstDayOfWeek: 0,
            dayNames: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "ששי", "שבת"],
            dayNamesShort: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
            dayNamesMin: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "ששי", "שבת"],
            monthNames: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],
            monthNamesShort: ["ינ", "פב", "מר", "אפר", "מאי", "יונ", "יול", "אוג", "ספ", "אוקט", "נוב", "דצ"],
            today: 'היום',
            clear: 'נקה',
            dateFormat: 'mm/dd/yy',
            weekHeader: 'שבוע'
        };
        // FilterUtils['dateRangeFilter'] = (value, filter: any[]): boolean => {
        //     const s = filter[0].getTime();
        //     const e = filter[1].getTime();
        //     const v = new Date(value).getTime();
        //     // compare it to the actual values
        //     return v >= s && v <= e;
        // };
        // FilterUtils['dateFromFilter'] = (value, filter): boolean => {
        //     const s = filter.getTime();
        //     const v = new Date(value).getTime();
        //     return v >= s;
        // };
        // FilterUtils['dateToFilter'] = (value, filter): boolean => {
        //     const e = filter.getTime();
        //     const v = new Date(value).getTime();
        //     return v <= e;
        // };
    }
    // sl(Amount: string) {
    //     const hh = this.itemsSource$.split(" ")[1];//שומר את הקוד 
    //     const j2 = this.Amount.split(" ")[0];//שומר את הסכום 
    //     return hh + j2
    // }
    ngOnDestroy(): void {
        // this.itemsSubscribe.unsubscribe();
    }
    viewRowDetails(itemId, selectedRow) {
        this.onViewDetails.emit({ itemId, selectedRow })
    }
    //#endregion

    //#region Events Methods
    public loadGridLazy(event: TableLazyLoadEvent) {
        this.loading = true;
        this.pageSize = event.rows;
        this.currentPage = event.first / this.pageSize + 1;
        this.sortField = event.sortField;
        this.sortDirection = event.sortOrder;
        // if (Object.keys(event.filters).length) {
        //     Object.keys(event.filters).forEach(element => {
        //         this.assignToFilter(element, event);
        //     });
        // }
        setTimeout(() => {
            const event = {}
            this.setRequest(event);
            this.onLoadData.emit(event);
            this.loading = false;
        }, 1);
    }
    setRequest(event) {
        event.Paging = { PageNo: this.currentPage, NumberRowsInPage: this.pageSize };
        event.Order = { OrderBy: this.sortField, OrderDirection: this.sortDirection };
        event.Filter = {};
        for (const key in this.filters) {
            const matchMode = this.filters[key].operator?.toString();
            if (matchMode == "dateFromFilter") {
                if (this.filters[key]?.value && new Date(this.filters[key].value).getFullYear() > 1900) {
                    event.Filter[key] = { From: this.filters[key]?.value };
                }
            }
            else
                if (matchMode == "dateToFilter") {
                    if (this.filters[key]?.value && new Date(this.filters[key].value).getFullYear() > 1900) {
                        event.Filter[key] = { To: this.filters[key]?.value };
                    }
                }
                else
                    if (matchMode == "dateRangeFilter") {
                        const from = this.filters[key]?.value[0];
                        const to = this.filters[key]?.value[1];
                        event.Filter[key] = {
                            From: from && new Date(from).getFullYear() > 1900 ? from : null,
                            To: to && new Date(to).getFullYear() > 1900 ? to : null
                        };
                    }
                    else
                        event.Filter[key] = this.filters[key].value;
        }
    }
    assignToFilter(key: string, event: any) {
        this.filters[key].field = key;
        this.filters[key].value = event.filters[key]?.value;
        this.filters[key].operator = event.filters[key]?.matchMode;

    }
    onRowExpandEvent(event) {
        this.onRowExpand.emit(event);
    }

    filter(dt, event, field, matchType) {
        dt.filter(event, field, matchType);
    }
    filterGlobal(freeText) {
        this.table.filterGlobal(freeSearchText, 'contains');
    }
    filterField(value, field) {
        this.table.filter(value, field, 'equals')
    }
    filterFieldIn(value, field) {
        this.table.filter(value, field, 'in')
    }
    exportCSV() {
        // const worksheet = XLSX.utils.json_to_sheet(this.items);
        // const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        // const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        // this.saveAsExcelFile(excelBuffer, "items");
        // this.messageService.showMessage(MessageTypes.info, 'GENERAL.FUTURE_DEVELOP', 'GENERAL.NOT_AVAILABLE_FEATURE', null, true);


    }
    onRowSelectEvent(event) {
        this.onRowSelect.emit(event);
    }

    onRowUnselectEvent(event) {
        this.onRowUnSelect.emit(event);
    }

    public changeFilter() {
        this.onChangeFilter.emit();
    }
    public paginate(event: any) {
        this.onPageChange.emit(event);
    }
    public addNew() {
        this.onAddNew.emit();
    }
    public rowSelect(event: any) {
        this.onRowClick.emit(event);
    }

    // reject() {
    // }
    public buildControlName(field: string, rowIndex: number) {
        const existingControl = this.findControl(field, rowIndex);
        if (existingControl) {
            return existingControl.controlName;
        }
        const controlName = `${field}-${rowIndex}-${Date.now()}`;
        this.controls.push({ controlName, field, rowIndex });
        return controlName;
    }
    public disableId(val) {
        return val !== EntityState.New.valueOf();
    }
    public colIsDisable(col, rowData) {
        return !this.colIsEnable(col, rowData);

    }
    public colIsEnable(col, rowData) {
        return col.editableMode === EditableMode.Edit ||
            col.editableMode === EditableMode.EditForNew && rowData.EntityState === EntityState.New;
    }
    public onChange(currentRow) {
        if (currentRow.EntityState !== EntityState.New) {
            currentRow.EntityState = EntityState.Modified;
        }
    }
    public columnClass(colWidth?, headerClass?) {
        let ngClass = 'th-background searchBtn';
        ngClass += ' ';
        switch (colWidth) {
            case 10:
                ngClass += 'width-10';
                break;
            case 25:
                ngClass += 'width-25';
                break;
            default:
                break;
        }
        if (headerClass) {
            ngClass += ' ' + headerClass;
        }
        return ngClass;
    }
    public findControl(field: string, rowIndex: number) {
        const control = this.controls ? this.controls.filter(c => x => x.field === field && x.rowIndex === rowIndex) : []
        if (control.length > 0) {
            return control[0];
        }
    }
    toString(value: any) {
        return String(value)
    }

    toggleSearch(event: any) {
        this.search = this.search ? false : true;
        this.labelSearch = this.search ? "GENERAL.HIDE_SEARCH" : "GENERAL.SEARCH";
    }
    clearFilter(columns) {
        columns.forEach(col => {
            col.fromDateFilter = null
            col.toDateFilter = null
        });
        const event = {}
        this.filters = []
        this.setRequest(event);
        this.onLoadData.emit(event);
        this.loading = false;

    }
    sortDate(col) {
        if (col.toDateFilter) {
            if (col.fromDateFilter)
                this.table.filter([col.fromDateFilter, col.toDateFilter], col.field, col.filterMatchMode);
            else
                this.table.filter(col.toDateFilter, col.field, 'dateToFilter');
        }
        else if (col.fromDateFilter) {
            this.table.filter(col.fromDateFilter, col.field, 'dateFromFilter');
        }
        else this.table.filter(new Date(-8640000000000000), col.field, 'dateFromFilter');
    }

getFullLink(value: string): string {
  if (!value) return '';
  const hasProtocol = value.startsWith('http://') || value.startsWith('https://');
  return hasProtocol ? value : 'http://' + value;
}
getLinkText(field: string, value: string): string {
  const fieldsToHideUrl = ['rouletteLink'];
  if (fieldsToHideUrl.includes(field)) {
    return this.localizationService.Translate("BUSINESS_COUPON.ROULETTE_LINK");
  }
  return value;
}
}
function freeSearchText(_freeSearchText: any, arg1: string) {
    throw new Error('Function not implemented.');
}

// function sl(Amount: string)
// {
//     const hh=this.Amount.split(" ")[1];//שומר את הקוד
//     const j2=this.Amount.split(" ")[0];//שומר את הסכום
//    return hh+j2
// }



